import { render, staticRenderFns } from "./BrandBlock.vue?vue&type=template&id=8a6369ee&scoped=true"
import script from "./BrandBlock.vue?vue&type=script&lang=js"
export * from "./BrandBlock.vue?vue&type=script&lang=js"
import style0 from "./BrandBlock.vue?vue&type=style&index=0&id=8a6369ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6369ee",
  null
  
)

export default component.exports